import React, { useEffect } from 'react'

import { CircularProgress, Container } from '@material-ui/core'
import { observer } from 'mobx-react'
import { Helmet } from 'react-helmet'

import { ScrollResetter } from 'shared/components/atoms'

import { PageHeader } from 'retailer/components/molecules'
import { PricingActionsCard, PricingRulesCard } from 'retailer/components/organisms'
import { SidebarLeftTemplate } from 'retailer/components/templates'
import { useStores } from 'retailer/stores/hooks'

import style from './PricingRulesPage.module.scss'

const PricingRulesPage = () => {
  const { pricingRulesStore, userProfileStore } = useStores()

  const { fetch, isLoaded } = pricingRulesStore
  const { markAdjustedPricingRules } = userProfileStore

  useEffect(() => {
    fetch()
    markAdjustedPricingRules()
  }, [])

  const main = (
    <Container maxWidth="xl" disableGutters className={style.PricingRulesContent}>
      <PageHeader title="Pricing rules" mb={3} />
      {isLoaded
        ? (
          <>
            <PricingRulesCard pricingRulesStore={pricingRulesStore} />
            <PricingActionsCard pricingRulesStore={pricingRulesStore} />
          </>
          )
        : <CircularProgress />}
    </Container>
  )

  return (
    <>
      <Helmet>
        <title>Pricing rules</title>
      </Helmet>
      <ScrollResetter />
      <SidebarLeftTemplate main={main} />
    </>
  )
}

export default observer(PricingRulesPage)
